/**
 * Created by uri.khaimov on 05/03/2017.
 */
export default {
    SET_USER_LOGO: 'SET_USER_LOGO',
    USER_LOGO: 'USER_LOGO'
}


// WEBPACK FOOTER //
// ./constants/header.js